import React from 'react';
import { useDeleteWorkplaceMutation } from '../../../../../graphql/graphql';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import ConfirmationModal from '../../../../Base/Components/Confirmation/ConfirmationModal';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import { WorkplacesTreeItem } from '../ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	item: WorkplacesTreeItem;
	isOpen: boolean;
	onClose: () => void;
	onChange: () => void;
}

const ManagerWorkplaceEdit = ({ item, isOpen, onClose, onChange }: Props) => {
	const [deleteWorkplaceMutation] = useDeleteWorkplaceMutation();
	const { displaySuccess, displayGQLError } = useApiClient();
	const { t } = useTranslation();

	const handleDelete = async () => {
		const result = await deleteWorkplaceMutation({ id: item.id });

		if ('error' in result) {
			displayGQLError(result);
		} else {
			displaySuccess('component.managerWorkplaceEdit.workplaceHasBeenDeleted');
			onChange();
		}
	};

	return (
		<ConfirmationModal
			title={'base.deleteConfirmationDefaultText'}
			text={`${t('component.workplaceAndWorkers.removeWorkplace')}: ${
				item.name
			}`}
			imageSource={'/dist/alert-triangle.svg'}
			isOpen={isOpen}
			onClose={onClose}>
			<Button theme={Theme.RED} onClick={handleDelete}>
				{'base.shared.confirm'}
			</Button>
		</ConfirmationModal>
	);
};

export default ManagerWorkplaceEdit;
